var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',{attrs:{"transfer":_vm.transfer,"split-panels":"","type":_vm.dateType,"value":_vm.value,"clearable":_vm.clearable,"placeholder":_vm.placeholder,"placement":_vm.placement,"format":_vm.format,"options":_vm.dateShortcut},on:{"on-change":function($event){_vm.$emit('on-change', $event), _vm.$emit('on-select-Shortcut', '')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cc3e8e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateRangePicker.vue
// module id = null
// module chunks = 